var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(90 -1034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-66.5,1034h-15a.5.5,0,0,0-.5.5v5.5h-7.5a.5.5,0,0,0-.5.5v17a.5.5,0,0,0,.5.5h23a.5.5,0,0,0,.5-.5v-23A.5.5,0,                 0,0-66.5,1034ZM-82,1052h-4v-2h4Zm0-6h-4v-2h4Zm0-3h-4.5a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5H-82v2h-4.5a.5.5,0,0,                 0-.5.5v3a.5.5,0,0,0,.5.5H-82v4h-7v-16h7Zm10,14h-4v-2.5a1.5,1.5,0,0,1,1.5-1.5h1a1.5,1.5,0,0,1,1.5,1.5Zm5,0h-4v-2.5a2.5,                 2.5,0,0,0-2.5-2.5h-1a2.5,2.5,0,0,0-2.5,2.5v2.5h-4v-22h14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81,1035v22h4v-2.5a2.5,2.5,0,0,1,2.5-2.5h1a2.5,2.5,0,0,1,2.5,2.5v2.5h4v-22Zm3.5,15h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-77.5,1050Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-77.5,1047Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-77.5,1044Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-77.5,1041Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-77.5,1038Zm4,12h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-73.5,1050Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-73.5,1047Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-73.5,1044Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-73.5,1041Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-73.5,1038Zm4,12h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-69.5,1050Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-69.5,1047Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-69.5,1044Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-69.5,1041Zm0-3h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1-69.5,1038Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87,1043.5v3a.5.5,0,0,0,.5.5H-82v2h-4.5a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5H-82v4h-7v-16h7v2h-4.5A.5.5,0,0,0-87,1043.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 185",
    d: "M-77,1037.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-77,1037.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 186",
    d: "M-73,1037.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-73,1037.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 187",
    d: "M-69,1037.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-69,1037.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 188",
    d: "M-77,1040.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-77,1040.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 189",
    d: "M-73,1040.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-73,1040.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 190",
    d: "M-69,1040.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-69,1040.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 191",
    d: "M-77,1043.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-77,1043.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 192",
    d: "M-73,1043.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-73,1043.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 193",
    d: "M-69,1043.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-69,1043.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 194",
    d: "M-77,1046.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-77,1046.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 195",
    d: "M-73,1046.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-73,1046.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 196",
    d: "M-69,1046.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-69,1046.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 197",
    d: "M-77,1049.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-77,1049.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 198",
    d: "M-73,1049.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-73,1049.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 199",
    d: "M-69,1049.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1A.5.5,0,0,1-69,1049.5Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureFlat);
export default __webpack_public_path__ + "static/media/feature-flat.4111182e3b9d2da007c2e6ac5a953fed.svg";
export { ForwardRef as ReactComponent };